import "./header.css";
import Dropdown from "../dropdown/Dropdown";
import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { getToken } from '../../services/LocalStorageService';
import { useGetLoggedUserQuery } from '../../services/userCRUDApi';
import { useEffect, useState } from 'react';
import { setUserInfo } from '../../features/userSlice';
import user_image from "../header/UserAfatar.jpg";
import { FiMenu} from "react-icons/fi";

const user_menu = [
  {
    content: "Dashboard",
    path: "/admin/dashboard",
  
  },
  {
    content: "Profile",
    path: "/admin/profile",
  
  },

  {
    content: "Logout",
    path: "/logout",
  
  },
];

const renderUserToggle = (user) => (
  <div className="header-user">
    <div className="header-user__image">
      <img src={user_image} alt="User profile" />
    </div>
    <div className="header-user__info">
      <div className="header-user__name">{user.first_Name} {user.last_Name}</div>
      <div className="header-user__role">{user.type}</div>
    </div>
  </div>
);

const renderUserMenu = (item, index) => (
  <Link to={item.path} key={index} className="dropdown-link">
    <div className="dropdown-item">
      <span className="dropdown-icon">{item.icon}</span>
      <span>{item.content}</span>
    </div>
  </Link>
);

const Header = ({ toggleSidebar }) => {
  const dispatch = useDispatch();
  const { access_token } = getToken();
  const { data, isSuccess } = useGetLoggedUserQuery(access_token);

  const [userData, setUserData] = useState({
    id: "",
    first_Name: "",
    last_Name: "",
    email: "",
    type: "",
  });

  useEffect(() => {
    if (data && isSuccess) {
      const updatedData = {
        id: data.first_Name,
        first_Name: data.first_Name,
        last_Name: data.last_Name,
        email: data.email,
        type: data.type,
      };
      setUserData(updatedData);
      dispatch(setUserInfo(updatedData));
    }
  }, [data, isSuccess, dispatch]);

  return (
    <header className="header">
      <div className="header-main">
        <div className="header-section left">
          <button className="menu-toggle" onClick={toggleSidebar}>
            <FiMenu size={24} />
          </button>
        </div>
        <div className="header-section right">

          <Dropdown
            customToggle={() => renderUserToggle(userData)}
            contentData={user_menu}
            renderItems={(item, index) => renderUserMenu(item, index)}
          />
        </div>
      </div>
      <div className="header-welcome">
        <h3>Welcome Back, {userData.first_Name}!</h3>
        <p className="welcome-message">Here's what's happening with your store today.</p>
      </div>
    </header>
  );
};

export default Header;